var _g, _g2, _g3, _path, _g4, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgRecommendationsIllustration = function SvgRecommendationsIllustration(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 119,
    viewBox: "0 0 208 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_363_10336)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_363_10336)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.5873,
    y: 5.5,
    width: 129.039,
    height: 76.3217,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.0873,
    y: 6,
    width: 128.039,
    height: 75.3217,
    rx: 3.5,
    stroke: "#EBEEF1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35.1115,
    y: 11.8914,
    width: 35.3634,
    height: 6.76744,
    rx: 2,
    fill: "#EBEEF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.1115,
    y: 20.5388,
    width: 21.0676,
    height: 6.76744,
    rx: 2,
    fill: "#EBEEF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.034,
    y: 11.8914,
    width: 21.0676,
    height: 6.76744,
    rx: 2,
    fill: "#EBEEF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.739,
    y: 20.5388,
    width: 35.3634,
    height: 6.76744,
    rx: 2,
    fill: "#EBEEF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.6356,
    y: 35.9534,
    width: 35.3634,
    height: 6.0155,
    rx: 2,
    fill: "#EBEEF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.6356,
    y: 58.8877,
    width: 35.3634,
    height: 6.0155,
    rx: 2,
    fill: "#EBEEF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.6356,
    y: 43.8489,
    width: 85.3988,
    height: 5.26357,
    rx: 2,
    fill: "#EBEEF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.6356,
    y: 66.783,
    width: 85.3988,
    height: 5.26357,
    rx: 2,
    fill: "#EBEEF1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.6163,
    cy: 38.9612,
    rx: 1.50483,
    ry: 1.50388,
    fill: "#EBEEF1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.6163,
    cy: 61.5195,
    rx: 1.50483,
    ry: 1.50388,
    fill: "#EBEEF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.2401,
    y: 41.217,
    width: 0.752413,
    height: 18.0465,
    rx: 0.376206,
    fill: "#EBEEF1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_363_10336)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_363_10336)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.0757,
    y: 30.6782,
    width: 129.039,
    height: 76.3217,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5757,
    y: 31.1782,
    width: 128.039,
    height: 75.3217,
    rx: 3.5,
    stroke: "#EBEEF1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 77.5998,
    y: 37.0696,
    width: 35.3634,
    height: 6.76744,
    rx: 2,
    fill: "#EBEEF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.5998,
    y: 45.717,
    width: 21.0676,
    height: 6.76744,
    rx: 2,
    fill: "#EBEEF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.523,
    y: 37.0696,
    width: 21.0676,
    height: 6.76744,
    rx: 2,
    fill: "#EBEEF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.227,
    y: 45.717,
    width: 35.3634,
    height: 6.76744,
    rx: 2,
    fill: "#EBEEF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.124,
    y: 61.1316,
    width: 35.3634,
    height: 6.0155,
    rx: 2,
    fill: "#EBEEF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.124,
    y: 84.0659,
    width: 35.3634,
    height: 6.0155,
    rx: 2,
    fill: "#EBEEF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.124,
    y: 69.0271,
    width: 85.3988,
    height: 5.26357,
    rx: 2,
    fill: "#EBEEF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.124,
    y: 91.9612,
    width: 85.3988,
    height: 5.26357,
    rx: 2,
    fill: "#EBEEF1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.1046,
    cy: 64.1394,
    rx: 1.50483,
    ry: 1.50388,
    fill: "#EBEEF1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.1046,
    cy: 86.6977,
    rx: 1.50483,
    ry: 1.50388,
    fill: "#EBEEF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.7285,
    y: 66.3953,
    width: 0.752413,
    height: 18.0465,
    rx: 0.376206,
    fill: "#EBEEF1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_363_10336)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.2084,
    cy: 44.9915,
    r: 13.8963,
    fill: "#F9FBFC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4994 46.6981C67.4182 46.2277 67.5749 45.7477 67.918 45.4158L69.8337 43.5628L67.1758 43.1769C66.7073 43.1089 66.302 42.8154 66.0913 42.3914L64.8996 39.9938L63.7079 42.3914C63.4972 42.8154 63.0919 43.1089 62.6234 43.1769L59.9655 43.5628L61.8812 45.4158C62.2243 45.7477 62.381 46.2277 62.2998 46.6981L61.847 49.3201L64.2318 48.0746C64.6502 47.8561 65.149 47.8561 65.5674 48.0746L67.9523 49.3201L67.4994 46.6981ZM67.383 41.7494L65.5455 38.0523C65.4236 37.8071 65.1734 37.6521 64.8996 37.6521C64.6258 37.6521 64.3756 37.8071 64.2537 38.0523L62.4162 41.7494L58.3047 42.3462C58.0325 42.3857 57.8065 42.5766 57.722 42.8384C57.6375 43.1001 57.7092 43.3872 57.9069 43.5784L60.8783 46.4526L60.1773 50.5119C60.1306 50.7822 60.2413 51.0557 60.4629 51.2173C60.6846 51.379 60.9787 51.401 61.2219 51.274L64.8996 49.3532L68.5773 51.274C68.8205 51.401 69.1146 51.379 69.3363 51.2173C69.5579 51.0557 69.6686 50.7822 69.6219 50.5119L68.9209 46.4526L71.8923 43.5784C72.09 43.3872 72.1617 43.1001 72.0772 42.8384C71.9927 42.5766 71.7667 42.3857 71.4945 42.3462L67.383 41.7494Z",
    fill: "#E5AE65"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_363_10336)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.7818,
    cy: 20.5764,
    r: 13.8963,
    fill: "#F9FBFC"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.473 21.8921C24.0663 21.8921 25.358 20.6004 25.358 19.0071C25.358 17.4137 24.0663 16.1221 22.473 16.1221C20.8796 16.1221 19.588 17.4137 19.588 19.0071C19.588 20.6004 20.8796 21.8921 22.473 21.8921ZM23.9155 19.0071C23.9155 19.8038 23.2696 20.4496 22.473 20.4496C21.6763 20.4496 21.0305 19.8038 21.0305 19.0071C21.0305 18.2104 21.6763 17.5646 22.473 17.5646C23.2696 17.5646 23.9155 18.2104 23.9155 19.0071Z",
    fill: "#5BACD7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.243 19.1382C28.243 23.728 22.473 27.6621 22.473 27.6621C22.473 27.6621 16.7029 23.728 16.7029 19.1382C16.7029 17.5731 17.3109 16.0722 18.3929 14.9655C19.475 13.8588 20.9427 13.2371 22.473 13.2371C24.0033 13.2371 25.4709 13.8588 26.553 14.9655C27.6351 16.0722 28.243 17.5731 28.243 19.1382ZM26.8005 19.1382C26.8005 20.8654 25.6824 22.6484 24.2997 24.1411C23.64 24.8532 22.9758 25.4396 22.473 25.8496C21.9702 25.4396 21.3059 24.8532 20.6462 24.1411C19.2635 22.6484 18.1454 20.8654 18.1454 19.1382C18.1454 17.9454 18.6091 16.8078 19.4243 15.974C20.2385 15.1413 21.3358 14.6796 22.473 14.6796C23.6101 14.6796 24.7074 15.1413 25.5216 15.974C26.3369 16.8078 26.8005 17.9454 26.8005 19.1382Z",
    fill: "#5BACD7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_363_10336",
    x: 19.5873,
    y: 1.5,
    width: 145.039,
    height: 92.3218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_363_10336"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_363_10336",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_363_10336",
    x: 25.5873,
    y: 4.5,
    width: 133.039,
    height: 80.3218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_363_10336"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_363_10336",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_363_10336",
    x: 62.0757,
    y: 26.6782,
    width: 145.039,
    height: 92.3218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_363_10336"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_363_10336",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_363_10336",
    x: 68.0757,
    y: 29.6782,
    width: 133.039,
    height: 80.3218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_363_10336"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_363_10336",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_363_10336",
    x: 43.3121,
    y: 27.0952,
    width: 43.7925,
    height: 43.7925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_363_10336"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_363_10336",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_363_10336",
    x: 0.885498,
    y: 2.68018,
    width: 43.7925,
    height: 43.7925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_363_10336"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_363_10336",
    result: "shape"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgRecommendationsIllustration);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "assets/illustrations/RecommendationsIllustration.9d4d6277d708642eda6a5020d23f6120.svg";